import { graphql } from '@/generated/gql';

export const RULE_EVALUATION_LOG_DETAIL_QUERY = graphql(/* GraphQL */ `
  query RuleEvaluationLogDetail($ruleId: UUID!, $evaluationLogId: UUID!) {
    tesseract {
      rule(id: $ruleId) {
        id
        evaluationLog(id: $evaluationLogId) {
          id
          createdAt
          ruleVersion {
            id
            status
            graph
            stats {
              id
              nodes {
                itemId
                hits
              }
              edges {
                itemId
                hits
              }
            }
          }
        }
      }
    }
  }
`);
